import { TextLink } from '@oneaudi/unified-web-components';
import { useCallback, useState } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { MoreInformationTrimlineDialogContent } from '~/app/pages/configurator/components/more-information-dialog/components/more-information-dialog-content';
import { showTrimlineMoreInformationDialog } from '~/app/pages/configurator/models/show-more-information-dialog';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { CatalogItemType } from '~/graphql/types';

export function MoreInformationTrimline({
	trimline,
	trackSelection,
	step,
	total,
}: {
	trimline: CatalogItemType['trimline'];
	trackSelection?: () => void;
	step: number;
	total: number;
}) {
	const { i18n } = useI18n();
	const [open, setOpen] = useState(false);
	const { changeConfiguration } = useConfigurator();
	const showMoreInformation = showTrimlineMoreInformationDialog(trimline);

	const onAddToConfiguration = () => {
		trackSelection && trackSelection();
		changeConfiguration(trimline);
		setOpen(false);
	};

	const onOpen = useCallback(
		(_open: boolean) => {
			appTrackingService.trackSelectionClickEvent({
				eventAction: EventAction.InternalLink,
				eventName: `selections - click to ${_open ? 'open' : 'close'} details layer`,
				label: i18n('ngc.actions.moreInfo'),
				elementName: 'text link',
				value: 'more information',
				category: 'trimline',
				elementCurrentStep: step,
				elementTotalSteps: total,
				item: trimline,
			});
			appTrackingService.viewChangeEvent({
				eventName: _open ? 'configurator - details layer' : 'generic',
				componentName: _open ? 'details-layer' : ' ',
				item: open ? undefined : trimline,
			});
			setOpen(_open);
		},
		[i18n, step, total, trimline, setOpen],
	);

	return showMoreInformation ? (
		<Dialog
			open={open}
			onCloseButtonClick={() => onOpen(false)}
			triggerElement={
				<TextLink variant={'standalone'} size={'sm'} onClick={() => onOpen(true)}>
					{i18n('ngc.actions.moreInfo')}
				</TextLink>
			}>
			<MoreInformationTrimlineDialogContent trimline={trimline} onAddToConfiguration={onAddToConfiguration} />
		</Dialog>
	) : null;
}
